/*
 * @Author: zhushitao
 * @Date: 2021-08-23 11:35:41
 * @LastEditors: zhushitao
 * @LastEditTime: 2021-11-03 15:39:25
 * @Description:
 */
import { configure, makeAutoObservable, observable } from 'mobx';
import { Lifecycle } from '../constants/hooks';

import Cmd from './cmd';
import Libraray from './libraray';
import { Spectator } from './spectator';
import { ELang, IAppContext } from './type';

configure({
  // 状态可以在任何地方修改 warning
  enforceActions: 'never',
  // isolateGlobalState: true,
});
const clientWidth = document.documentElement.clientWidth;
class AppContext<T, C> implements IAppContext<T, C> {
  public $refs: Record<string, any> = {
    $app: null,
  };
  public libraray = new Libraray();
  /** 用户信息 */
  public userInfo = {};
  /** 渲染配置 */
  public renderConfig = {};
  /** 留言表单相关信息 */
  public watchOfflineForm = {};
  /** 应用状态 */
  public appStatus = Lifecycle.APP_WILL_MOUNT;
  /** 会话信息 */
  public dialogInfo = {};
  /** 应用loading */
  public appLoading = true;
  // 回复消息
  public replyMessage = {};
  public watchAppDidMount = {};
  public utils = {};
  public uiConfig = {};
  public dialog = {};
  public messages = [];
  public ext = {};
  public query = {
    isPc: clientWidth >= 440,
  };
  public themes = {};
  //事件
  public eventBus = new Spectator();

  //触发事件标准
  public triggerEvent?: (eventCode: string, data: any) => any;
  public lang = ELang.zh;
  public mountId: HTMLDivElement | undefined;
  public autoComplete = {};
  public cmd: Cmd = new Cmd(this);

  constructor(query?: Record<string, string | boolean>) {
    if (query) {
      this.query = {
        ...this.query,
        ...query,
      };
    }
    makeAutoObservable(
      this,
      {
        $refs: observable.ref,
        renderConfig: observable,
        messages: observable.ref,
        dialog: observable.ref,
        userInfo: observable.ref,
        themes: observable,
        lang: observable,
        watchAppDidMount: observable,
        ext: observable.deep,
        utils: observable.ref,
        autoComplete: observable,
        uiConfig: observable,
        eventBus: observable.ref,
        dialogInfo: observable,
        appLoading: observable,
        appStatus: observable,
        replyMessage: observable,
      },
      {
        autoBind: true,
      },
    );
  }

  public input = {
    setRenderStatus: (status: string) => {
      this.$refs?.$app?.current?.setRender('appBottom', status);
    },
  };
}

export default AppContext;
